import React from "react";
import UserForm from "../../containers/UserForm";

const NewUserRoute = () => (
  <div data-testid="new-user-route">
    <UserForm />
  </div>
);

export default NewUserRoute;
